import React, { useEffect, useState } from 'react';
import '../static/table.css';
import '../static/popup.css';
import axios from 'axios';
import { Link } from 'react-router-dom';

const CatWalking = () => {


  const [groomingData, setGroomingData] = useState([]);
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split('T')[0]; // yyyy-mm-dd
  

  useEffect(() => {
    axios.get(`/cat_walking`)
      .then((res) => {
        setGroomingData(res.data);
      })
      .catch((err) => console.error("Failed to fetch grooming data:", err));
  }, []);


  const [showPopup, setShowPopup] = useState(false);
  const handleClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

   

  return (
    <div className="container">
      <h2 className="text-center">Pet Walking Appointments</h2>
      <div>
      <button type="button" className='button' onClick={handleClick}>
        Add Pet Walking Appointment
      </button>

      {showPopup && (
        <div className="popup" style={{alignContent: 'center'}}>
          <div className="popup-inner">
            <h2>Pet Walking</h2>
            <button className='button' onClick={closePopup}>Close</button>
            {/* Put your form or content here */}
          </div>
        </div>
      )}
    </div>
      <div className="row">
        <div className="col-12">
          <div className="table-responsive" data-pattern="priority-columns">
            <table
              className="table table-bordered table-hover"
              summary="Responsive Pet Walking appointment table using RWD-Table-Patterns"
            >
              <caption className="text-center">
              Pet Walking
                <h3 target="_blank" rel="noopener noreferrer"> solution</h3>:
              </caption>
              <thead>
                <tr>
                  <th data-priority="0">owner</th>
                  <th data-priority="1">owner Points</th>
                  <th data-priority="2">pet</th>
                  <th data-priority="3">phone</th>
                  <th data-priority="4">address</th>
                  <th data-priority="5">Start Day</th>
                  <th data-priority="6">End Day</th>
                  <th data-priority="5">Start Time</th>
                  <th data-priority="6">End Time</th>
                  <th data-priority="6">Note</th>
                </tr>
              </thead>
              <tbody>
                {groomingData.map((item, index) => (
                  <tr key={index.owner_name}>
                    <td>{item.owner_points}</td>
                    <td>{item.pet_name}</td>
                    <td>{item.owner_phone}</td>
                    <td>{item.owner_address}</td>
                    <td>{item.days}</td>
                    <td>{item.daye}</td>
                    <td>{item.times}</td>
                    <td>{item.timee}</td>
                    <td>{item.note}</td>
                    <td>
                      <Link to={`/historygroom/${item.Pet}`}>Go to Pet Page</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="7" className="text-center">
                    Arys Pet Walking  
                     
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

    </div>
  );
};

export default CatWalking;
